var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14127_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.799973L12.3584 0.0847732C12.2472 0.0290268 12.1244 0 12 0C11.8756 0 11.7528 0.0290268 11.6416 0.0847732L12 0.799973ZM7.2 13.6V12.8H6.4V13.6H7.2ZM13.6 13.6H14.4V12.8H13.6V13.6ZM0 24H24V22.4H0V24ZM11.6416 0.0847732L2.0416 4.88477L2.7584 6.31517L12.3584 1.51517L11.6416 0.0847732ZM0 9.59997H24V7.99997H0V9.59997ZM21.9584 4.88477L12.3584 0.0847732L11.6416 1.51517L21.2416 6.31517L21.9584 4.88477ZM1.6 8.79997V23.2H3.2V8.79997H1.6ZM20.8 8.79997V23.2H22.4V8.79997H20.8ZM8 23.2V13.6H6.4V23.2H8ZM7.2 14.4H13.6V12.8H7.2V14.4ZM12.8 13.6V23.2H14.4V13.6H12.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14127_843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.1b98947fc57fcd49f2394550dcc0bb85.svg";
export { ForwardRef as ReactComponent };